
import React from 'react';

import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner'
import {  Link } from "react-router-dom"
//import history from "../../../history"

import { Icon, Button as SVAButton} from 'antd';

//import SVLoginabodeBody from './loginAbodeBody'
import '../../../css/svformwerror.css'

const _ = require('lodash')
//const {Link} = require("react-router")



/*
import Cookies from 'universal-cookie';
const cookies = new Cookies();
cookies.set('myCat', 'Pacman', { path: '/' });
console.log(cookies.get('myCat')); // Pacman

*/
//var cookie = require('cookie');
const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );


const HeartIcon = props => <Icon component={HeartSvg} {...props} />;



class SVProfilecosmosContainer extends React.Component {
    

    constructor(props) {
        super(props)
        let me = this
        this.getLBContainersTerrain= this.getLBContainersTerrain.bind(this)
        this.getAppDetails = this.getAppDetails.bind(this) 
        this.userLogout = this.userLogout.bind(this) 
        this.getReserveHtmlSubmenu = this.getReserveHtmlSubmenu.bind(this)
        
        this.title = 'AddressContainer'
       // this.svsubmitparent = this.svsubmitparent.bind(this)

        //this.getLoginBoardBody  = this.getLoginBoardBody.bind(this)
        this.closecbParent = this.closecbParent.bind(this)
        
      
    }
    componentDidMount() {
        this.syncProfileCookie();
    }
    
    componentDidUpdate() {
        this.syncProfileCookie();
    }
    
    syncProfileCookie() {
        const { cookies, hk_data_profile: profile } = this.props;
    
        if (!cookies || !profile || profile.customerId <= 0) {
            return;
        }
    
        const token = profile.token;
    
        if (typeof token !== "string" || token.length <= 10) {
            return;
        }
    
        // Write only when the token changes.
        if (cookies.get("svt") !== token) {
            cookies.set("svt", token, { path: "/" });
        }
    }
    getReserveHtmlSubmenu(det,customerId){
        console.log('SV*****render MARCH 20, 2025 getReserveHtmlSubmenu ')
        console.log('SV*****render getReserveHtmlSubmenu ', det)
        console.log('render getReserveHtmlSubmenu ', customerId)
        if(customerId > 0){
            console.log('SV***** getReserveHtmlSubmenu Block 1 ')
            return(
            <div className="col-xs-12" style={{"display":"block"}}>
                    <ul id="subNavDiv" style={{marginTop:'13px'}} className="hopper-nav list-horizontal pull-right">
                        <li><strong>My Profile</strong>
                        </li>
                        <li><Link to={`/myaccountSV/${det.customerId}/mystoredcardList`}>My Payment Cards   </Link> 
                        </li>
                        <li><Link to={`/myaccountSV/${det.customerId}/myaddressList`}> My AddressList   </Link> 
                        </li>
                        
                        <li><Link to={`/myaccountSV/${det.customerId}/mysvspacelist`}> My Rservations   </Link>
                        </li>
                        <li><Link to={`/myaccountSV/${det.customerId}/svflighttripslist`}> My Flight Trips   </Link>
                        </li>
                        <li><Link to={`/myaccountSV/${det.customerId}/mysvspaceSearch`}> My Space Search  </Link>
                        </li>
                        <li><Link to={`/myaccountSV/${det.customerId}/mysvflyspaceSearch`}> My Flight Search  </Link>
                        </li>
                        <li><a href="#" onClick={()=>this.userLogout()} >Logout</a>
                        </li>
                    
                    </ul>
            </div>
            )
        }else{
            console.log('SV******123 getReserveHtmlSubmenu Block SHOW NOTHING BAD LOGIN ')
            return(
            <div className="col-xs-6" style={{"display":"block"}}>
                
               
        
            </div>   
            )
        }
        
    }
/*
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        console.log(this.props.svparams)
         //console.log(this.props.svparams.id)
         let id;
         if(this.props.svparams){
            id = this.props.svparams.id
         
         }else{
          console.log('not called by router we might be creat')
          id = -11;
         }
         console.log('sv***Mar21 Cookies start 1')
         const { cookies } = this.props;
         console.log('sv***Mar21 Cookies start 2')
         console.log(cookies)
         console.log('sv***Mar21 Cookies start 3')
         let svcook = "yyXX"
        
 
           cookies.set('svcook', svcook, { path: '/' });

     
        // var setCookie = cookie.serialize('svcook', 'svtoken=yyXX');
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    
      // this.getAppDetails(id)
       // this.props.priceAndTexNow(id);
   
			
			
	

	}
    */
    getAppDetails(paramQSpaceId){
        //loadReguserDet(id)
        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        if(id < 0){
            console.log("id*  cerate ********", id)
            return
        }
        /*
        console.log("id*SV*** APR9 customer id TO CODE loadProfileWithIdt******", id)
        let credob ={"usercredNew":{"username":"jon@yahoo.com","password":"Pete123"}}
       this.props.loadUserProfileByCustIdNow(credob)

       */
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    userLogout(){
        this.props.svlogoutAction();
    }
    /*
    svsubmitparent(values){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv submit callback**********parent')
      console.log(values)
     
     
      let comCardAndTraveller = {
        usercredNew : values
       
      }  
      
     return this.props.authenticateUsercredNow(comCardAndTraveller)
  
    }
*/
    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
       
        console.log('sv***Mar21 renderrr Cookies start 1')
        const {cookies} = this.props
       
       
        console.log('sv***Mar21 render Cookies start 2')
        console.log(cookies)
        console.log('sv***Mar21 render Cookies start 3')

        let det = {
            "id": -1,
            "username": "alen@yahoo.com",
            "password": "Pete123"
           
        }
        if (this.props.hk_data_profile ) {
            det = this.props.hk_data_profile
            
          
        }
       
        console.log('%%%%%%%%START%%%%%%%%% this.props.hk_data_profiled')
        console.log(this.props.hk_data_profile)
        console.log('%%%%%%%%%%%END%%%%%% this.props.my_data_profiled')
        
       let svdisplayLogin = "block"
       let displayDet = "none"
       let customerId = -1
       
       if(this.props.hk_data_profile  &&(this.props.hk_data_profile.customerId < 0)){
            console.log("id*SV***m1 APR9 customer id TO CODE loadProfileWithIdt******", this.props.hk_data_profile.customerId)
           // console.log(this.props)
            //WE ASV SVPARAMS.ID
            /*
            let credob ={"usercredNew":{"username":"jon@yahoo.com","password":"Pete123"}}
            this.props.loadUserProfileByCustIdNow(credob)
            */
           /*
           const {svparams} = this.props
           let credob ={"usercredNew":{"customerId":"7"}}
           let myob =  credob.usercredNew
           if(svparams && (svparams['id'].length > 0) ){
              
              myob['customerId'] =  svparams.id

           }
           console.log(credob)
           console.log("id*SV***** APR9 customer id TO CODE loadProfileWithIdt*** END****")
            
            
            this.props.loadUserProfileByCustIdNow(credob)

          //  "customerId":"7"
          */
        
       }else{
        customerId = this.props.hk_data_profile.customerId
        svdisplayLogin = "none"
        /*
        if(this.props.hk_data_profile &&(this.props.hk_data_profile.token)  &&(this.props.hk_data_profile.token.length > 10)){
            cookies.set('svt', this.props.hk_data_profile.token, { path: '/' });
         }else{
            cookies.set('svt', "ggnnmm", { path: '/' });
         }
         */

         /*
            let redire_path = `/myaccountSV/${customerId}`
            console.log(redire_path)
        history.push(redire_path)
       */
       }
       /*
       if(customerId > 0){
        svdisplayLogin = "none"
       }else{
        svdisplayLogin = "block"
       }
       if(svdisplayLogin === "block"){
          
            displayDet = "none"
       } else{
           
             displayDet = "block"
       }
       console.log('svgar=e RECIRSE SVAP chart render_____________________________svdisplayLogin :' + svdisplayLogin)
       console.log('displayDet is ',displayDet)
       */
       if(this.props.error && this.props.errob){
        console.log('sv**container ger errob')
        console.log(this.props)
       return (
         <div >
            
             <div style={{paddingTop:'10px'}}>
               <ErrorCom  errob={this.props.errob} ></ErrorCom>
             </div>
             <div style={{paddingTop:'10px'}}>
                 <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svlogin`}> My Reservations   </Link></SVAButton>
             </div>
            
          </div>   
            )

      }else if(this.props.loading ){
       return (

            <div >
                 <h3>Spinner*****</h3>
                <div style={{paddingTop:'10px'}}>
    
                <SVAbodeSpinner />
                </div>
        
             </div>   

       
             )

      }else {

      
            return (
                
                <div>
                    {this.getReserveHtmlSubmenu(det,customerId)}
                    
                    <div className="col-xs-12" >
                            
                        
                                                
                                                    
                                                    <div >
                                                        {/*  
                                                        
                                                        <h1 style={{fontSize: "16px", color:'black',marginBottom:"30px"}}>HOME -Welcome :{det.fname}</h1>
                                                            <h3 style={{fontSize: "16px", color:'black',marginBottom:"30px"}}>My Profile Summary </h3>
                                                            <div className="rev-row">
                                                                <div className="card card--raised with-shadow">

                                                                    <p className="right-sd-content"> <text>{det.username? det.username:'None' }  </text></p>
                                                                    <p className="right-sd-content"> <text>{det.customerId }  </text></p>
                                                                    <p className="right-sd-content"> <text>{det.email? det.email:'None' }  </text></p>
                                                                    <p className="right-sd-content"> <text>{det.phone? det.phone:'None' }  </text></p>
                                                                    <p className="right-sd-content"> <text>{det.login? det.login:'None' }  </text></p>
                                                                </div>
                                                            </div>
                                                        */}
                                                        
                                                            { this.getLBContainersTerrain(displayDet,det) }
                                                        
            
                                                    </div>   
                                                    
            
                    </div>
                </div>
                )
                
       }
    }
    getLBContainersTerrain(displayDet, det) {

        return (
            <div className="svr-det-pageWrapper">
                <header className="svr-header1">
                    <h1><span><text style={{color:'#f0d8a9'}}><Icon  style={{ marginRight:'5px',color: '#aab838' }} type="home" theme="filled" /> HOME Customer Profile Information  </text></span> </h1>
                </header>
               
                                                    
                                                    <div className="rev-row">
                                                        <div className="card card--raised with-shadow">

                                                            <p className="right-sd-content"> <text>{det.username? det.username:'None' }  </text></p>
                                                            <p className="right-sd-content"> <text>{det.customerId }  </text></p>
                                                            <p className="right-sd-content"> <text>{det.email? det.email:'None' }  </text></p>
                                                            <p className="right-sd-content"> <text>{det.phone? det.phone:'None' }  </text></p>
                                                            <p className="right-sd-content"> <text>{det.login? det.login:'None' }  </text></p>
                                                        </div>
                                                    </div>
       
               
             
           </div>   
             )   
    }
    /*
    getLoginBoardBody(det,userLogout,svsubmitparent){
        if(this.props.error){

         console.log('sv**container ger errob')
                    let errob = {
                        "timestamp": "2015-08-23T02:27:18.038+0000",
                        "status": 500,
                        "error": "FlyServer Error",
                        "message": "Username or Password is Incorrect and try again",
                        "path": "/kk/svaddressDetailPost"
                    }
                    let today_dt = new Date()
                    errob["timestamp"] = today_dt
                   return (
                     <div >
                        
                         <div style={{paddingTop:'10px'}}>
                           <ErrorCom  closecbParent={this.closecbParent} errob={errob} ></ErrorCom>
                           <SVLoginabodeBody det={det} userLogout={userLogout}  svsubmitparent={svsubmitparent} ></SVLoginabodeBody>
                         </div>
                        
                        
                      </div>   
                        )
           
        }else{
            
            return (
                <SVLoginabodeBody det={det} userLogout={userLogout}  svsubmitparent={svsubmitparent} ></SVLoginabodeBody>
                                                       
            )

        }
        
    }
    */
closecbParent(){
   
        console.log('svCustomerId*********')
        this.props.clearformUsercred()
       
       // history.push(`/svlogin`)
}

}


//const SVProfilecosmosContainer   = withCookies(SVProfilecosmosContainer)

export default SVProfilecosmosContainer